import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[appDebounceClick]'
})
export class DebounceClickDirective{
  @Input() debounceTime = 2500; // 防抖间隔（毫秒）
  @Output() debounceClick = new EventEmitter<Event>();

  private lastClickTime = 0;

  @HostListener('click', ['$event'])
  handleClick(event: Event): void {
    const now = Date.now();

    // 如果距离上次点击不足 debounceTime，则拦截此次点击
    if (now - this.lastClickTime < this.debounceTime) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.lastClickTime = now;
    this.debounceClick.emit(event);
  }
}

